import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Box, IconButton, Tooltip} from '@mui/material';

export const ClickIdValue = ({value}: {value: string}) => {
  return (
    <Box component="span" display="inline-flex" alignItems="center" gap={0.5}>
      <Box component="span" sx={{fontFamily: 'monospace'}}>
        {value}
      </Box>
      <Tooltip title="Copy ClickID">
        <IconButton
          size="small"
          onClick={() => void navigator.clipboard.writeText(value)}
        >
          <ContentCopyIcon sx={{fontSize: 14}} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
